/**
 * External dependencies
 */

import React from "react";
import classnames from "classnames";
import { Box } from "@towersystems/towersystems-design-system";

/**
 * Style dependencies
 */
import "./styles.scss";

const FormFieldset = ({ className, children, ...otherProps }) => (
  <Box
    component="fieldset"
    {...otherProps}
    className={classnames(className, "form-fieldset")}
  >
    {children}
  </Box>
);

export default FormFieldset;
